<div class="container">
    <h2>Insert Dish</h2>
    <form action="" method="POST">
      <div class="form-group">
        <label for="name">Dish name:</label>
        <input type="text" class="form-control" id="name" name="name" #name>
      </div>
      <div class="form-group">
        <label for="description">Description:</label>
        <input type="text" class="form-control" id="description" name="description" #description>
      </div>
      <div class="form-group">
        <label for="price">Price:</label>
        <input type="number" class="form-control" id="number" name="number" #price>
      </div>
      <button type="submit" class="btn btn-primary" (click)="onsubmit($event, name.value, description.value, price.value)">Submit</button>
    </form>
  </div>